import type { JellyfinRemoteSession } from '../api/jellyfin';

export function getRemoteSessionCommands(session: JellyfinRemoteSession): string[] {
  return session.SupportedCommands ?? session.Capabilities?.SupportedCommands ?? [];
}

export function getRemoteSessionMediaTypes(session: JellyfinRemoteSession): string[] {
  return session.PlayableMediaTypes ?? session.Capabilities?.PlayableMediaTypes ?? [];
}

export function isControllableRemoteSession(
  session: JellyfinRemoteSession,
  localDeviceId: string,
): boolean {
  const id = session.Id ?? session.DeviceId;
  if (!id || session.DeviceId === localDeviceId || id === localDeviceId) return false;
  const supportsControl = session.SupportsRemoteControl
    ?? session.SupportsMediaControl
    ?? session.Capabilities?.SupportsMediaControl
    ?? false;
  if (!supportsControl) return false;
  const mediaTypes = getRemoteSessionMediaTypes(session);
  return mediaTypes.length === 0 || mediaTypes.some((type) => /audio|video/i.test(type));
}

export function getRemoteSessionId(session: JellyfinRemoteSession): string {
  return session.Id ?? session.DeviceId ?? '';
}

export function getRemoteProgress(session: JellyfinRemoteSession): {
  positionTicks: number;
  durationTicks: number;
  ratio: number;
} {
  const positionTicks = Math.max(0, session.PlayState?.PositionTicks ?? 0);
  const durationTicks = Math.max(0, session.NowPlayingItem?.RunTimeTicks ?? 0);
  return {
    positionTicks,
    durationTicks,
    ratio: durationTicks > 0 ? Math.max(0, Math.min(1, positionTicks / durationTicks)) : 0,
  };
}

export function formatRemoteTime(ticks: number): string {
  const totalSeconds = Math.max(0, Math.floor(ticks / 10_000_000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    : `${minutes}:${String(seconds).padStart(2, '0')}`;
}
